"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuiltInWowUrlConverterType = exports.BuiltInLookupFetcherType = void 0;
var BuiltInLookupFetcherType;
(function (BuiltInLookupFetcherType) {
    /**
     * Use a configuration file inside a GitHub
     * repository as the translation table.
     */
    BuiltInLookupFetcherType[BuiltInLookupFetcherType["GitHub"] = 0] = "GitHub";
    /**
     * TODO(@tianhaoz95): add fetcher implementation
     */
    BuiltInLookupFetcherType[BuiltInLookupFetcherType["Gist"] = 1] = "Gist";
    /**
     * TODO(@tianhaoz95): add fetcher implementation
     */
    BuiltInLookupFetcherType[BuiltInLookupFetcherType["LocalFile"] = 2] = "LocalFile";
    /**
     * TODO(@tianhaoz95): add fetcher implementation
     */
    BuiltInLookupFetcherType[BuiltInLookupFetcherType["CustomBackend"] = 3] = "CustomBackend";
})(BuiltInLookupFetcherType = exports.BuiltInLookupFetcherType || (exports.BuiltInLookupFetcherType = {}));
var BuiltInWowUrlConverterType;
(function (BuiltInWowUrlConverterType) {
    BuiltInWowUrlConverterType[BuiltInWowUrlConverterType["Basic"] = 0] = "Basic";
})(BuiltInWowUrlConverterType = exports.BuiltInWowUrlConverterType || (exports.BuiltInWowUrlConverterType = {}));
